export const ARROW_ROTATION_STATE = Object.freeze({
    "DEFAULT": 0,
    "ROTATING_DOWN": 1,
    "DOWN": 2,
    "ROTATING_RIGHT": 3,
    "RIGHT": 4
});